export interface Breadcrumb {
  label: string;
  url?: string | null;
}

export default {
  addBreadcrumb({ commit, state }, crumb: Breadcrumb) {
    // Prevent adding duplicate crumbs
    if (state.breadcrumbs.some((c) => c.label === crumb.label)) return;
    setTimeout(() => {
      // Re-check at commit time. Several addBreadcrumb calls can queue before any
      // of these timeouts run (e.g. the customer page's currentUser watcher
      // firing repeatedly in one tick), and the synchronous guard above sees
      // stale state for all but the first — so without this each queued call
      // would concat the same crumb, duplicating it.
      if (state.breadcrumbs.some((c) => c.label === crumb.label)) return;
      commit("replace", {
        state: "breadcrumbs",
        data: state.breadcrumbs.concat([crumb])
      });
    });
  },
  removeBreadcrumb({ commit, state }, crumb: Breadcrumb) {
    // Remove by label
    commit("replace", {
      state: "breadcrumbs",
      data: state.breadcrumbs.filter((_crumb) => _crumb.label !== crumb.label)
    });
  },
  setBreadcrumbs({ commit }, crumbs: Breadcrumb[]) {
    commit("replace", {
      state: "breadcrumbs",
      data: crumbs
    });
  }
};
